import * as React from "react";
import type { SVGProps } from "react";
const SvgLuxair = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 50 50"
    width="100%"
    height="100%"
    {...props}
  >
    <g fill="#00abbf">
      <path d="M29.267 7.035 8.11 32.482c-.218.24-.3.528-.202.751.098.24.316.387.62.387l32.695.005c.294 0 .5-.25.5-.528 0-.289-.135-.457-.424-.523-1.176-.277-7.595-1.666-12.206-3.06-2.859-.865-3.975-3.32-3.23-6.598.823-3.631 4.308-15.304 4.318-15.337.082-.24.028-.544-.223-.664-.277-.153-.517-.082-.691.12" />
      <path d="M25.04 2C37.7 2 48 12.306 48 25.063c0 12.642-10.3 22.959-22.96 22.959C12.3 48.022 2 37.705 2 25.062 2 12.313 12.3 2 25.04 2m0 2.815c-11.171 0-20.23 9.06-20.23 20.253 0 11.161 9.059 20.22 20.23 20.22 11.173 0 20.238-9.059 20.238-20.22A20.187 20.187 0 0 0 25.04 4.815" />
    </g>
  </svg>
);
export default SvgLuxair;
